import React from 'react';
import { faWeightHanging } from '@fortawesome/pro-solid-svg-icons';
import { Icon } from 'js/components';
import StrokedText from '../../Participation/Nodes/StrokedText';

export const ORG_TREE_WEIGHT_ICON_SIZE = 10;

export function formatOrgTreeWeight(weight) {
  if (weight == null || !Number.isFinite(weight)) {
    return null;
  }
  const rounded = Math.round(weight * 100) / 100;
  return Number.isInteger(rounded) ? String(rounded) : String(rounded);
}

/** Weight label (icon + stroked value). Parent sets `transform` for positioning. */
const OrgTreeWeightBadge = ({ weight, transform, reverse = true }) => {
  const label = formatOrgTreeWeight(weight);
  if (label == null) {
    return null;
  }

  return (
    <g className="org-tree-weight" transform={transform}>
      <svg
        viewBox={`0 0 ${ORG_TREE_WEIGHT_ICON_SIZE} ${ORG_TREE_WEIGHT_ICON_SIZE}`}
        width={ORG_TREE_WEIGHT_ICON_SIZE}
        height={ORG_TREE_WEIGHT_ICON_SIZE}
      >
        <Icon
          icon={faWeightHanging}
          className="icon-weight"
          transform="shrink-3"
        />
      </svg>
      <StrokedText
        textAnchor={reverse ? 'end' : 'start'}
        fill="#fff"
        x={reverse ? -3 : ORG_TREE_WEIGHT_ICON_SIZE + 3}
        y={ORG_TREE_WEIGHT_ICON_SIZE / 2 + 1}
        dominantBaseline="middle"
        fontSize={ORG_TREE_WEIGHT_ICON_SIZE}
        strokeColor="#2c2c2c"
        strokeWidth="3"
      >
        {label}
      </StrokedText>
    </g>
  );
};

export default OrgTreeWeightBadge;
